<template>  
  <div class="header__dropdown-container">
    <div class="header__dropdown-container-inner">
      <div class="header__dropdown-container-links-large-image-container" v-if="block.link_list_active">
        <div class="header__dropdown-container-inner-featured-menu-links-container">
          <div class="header__dropdown-side-list" v-if="block.featured_link_list_active">
            <ul class="header__dropdown-list" v-for="(link, index) in block.featured_link_list">
              <li v-if="block.title"><a class="header__dropdown-list-title header__dropdown-featured-link link link--primary" :href="link.url">{{ link.title }}</a></li>
            </ul>
          </div>
          <div class="header__dropdown-lists-container header__dropdown-list-menu-links-main-container">
            <ul class="header__dropdown-list header__dropdown-list-menu-links-container" v-for="(link, index) in block.link_list">
              <li class="header__dropdown-list-links-image-container">
                <div class="header-dropdown-list-links-container"><a class="header__dropdown-list-title link link--primary" :href="link.url" :class="{'header__dropdown-list-title--margin-bottom-none': !(link.children && link.children.length > 0)}">{{ link.title }}</a>
                  <ul v-for="(child_link, index) in link.children">
                    <li class="header__dropdown-list-item"><a class="header__dropdown-link link link--primary" :href="child_link.url">{{ child_link.title }}</a></li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="header__dropdown-images--large-image-inner-container">
          <div class="header__dropdown-images-large-image clip-transition"><img class="header__dropdown-large-image" :src="block.large_image" :alt="block.large_image_title"/></div>
          <div class="header__dropdown-images--large-image-description-container">
            <p class="header__dropdown-images--large-image-title" v-if="block.large_image_title">{{ block.large_image_title}}</p>
            <div class="header__dropdown-images--large-image-description" v-if="block.large_image_description" v-html="block.large_image_description">{{ block.large_image_description }}</div><a class="header__dropdown-images--large-image-link link link--primary" v-if="block.large_image_link" :href="block.large_image_link">{{ block.large_image_link_text }}
              <icon class="menu-image-link-arrow" name="arrow_long_right" size="24px"></icon></a>
          </div>
        </div>
      </div>
      <div class="header__dropdown-images--large-image-container" v-else>
        <div class="header__dropdown-images--large-image-inner-container">
          <div class="header__dropdown-images-large-image clip-transition"><img class="header__dropdown-large-image" :src="block.large_image" :alt="block.large_image_title"/></div>
          <div class="header__dropdown-images--large-image-description-container">
            <p class="header__dropdown-images--large-image-title" v-if="block.large_image_title">{{ block.large_image_title}}</p>
            <div class="header__dropdown-images--large-image-description" v-if="block.large_image_description" v-html="block.large_image_description">{{ block.large_image_description }}</div><a class="header__dropdown-images--large-image-link link link--primary" v-if="block.large_image_link" :href="block.large_image_link">{{ block.large_image_link_text }}
              <icon class="menu-image-link-arrow" name="arrow_long_right" size="24px"></icon></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarDesktopTextLargeImage',
  components: {
    Icon
  },
  props: {
    block: Object
  }
}
</script>
<style scoped lang="scss">
  .header__dropdown-container {
    background-color: $color-white;

    @include desktop-up {
      position: absolute;
      width: 100%;
      left: 0;
      top: 99%;
      border-bottom: 1px solid #ecece1;
      background-color: #FAFAFA;
      z-index: 1;
      padding-top: 40px;
      padding-bottom: 80px;
      display: none;
    }
  }

  .header__dropdown-featured-link {
    display: flex;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 22px;

    &:before {
      background: $color-black;
    }
  }

  .header__dropdown-lists-container {

    @include desktop-up {
      display: flex;
      flex-flow: column wrap;
      flex-direction: column;
      height: 264px;
      overflow: hidden;
    }
  }

  .header__dropdown-list-menu-links-container {
    @include desktop-up {
      margin-bottom: 12px;
    }
  }

  .nav-links-dropdown-content-container {

    @include desktop-up {
      display: block;
    }
  }

  .header__dropdown-container-inner {
    display: flex;
    flex-direction: column;
    width: 100%;

    @include desktop-up {
      flex-direction: row;
      justify-content: space-between;
      max-width: $container-max-width;
      margin-left: auto;
      margin-right: auto;
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .header__dropdown-side-list {
    border-right: 1px solid $color-grey;
    padding-left: 0;
    padding-right: 16px;
    list-style: none;
    margin-right: 31px;
    margin-bottom: 0;
    width: 192px;
  }

  .header__dropdown-side-list .header__dropdown-list {
    margin-bottom: 0;
  }

  .header__dropdown-list {

    @include desktop-up {
      width: 192px;
      margin-right: 32px;
    }
  }

  .header__dropdown-list,
  .header__dropdown-list ul {
    padding-left: 0;
    list-style: none;
  }

  .header__dropdown-list-title {
    margin-bottom: 12px;
    color: $color-text-black;
    font-family: $font-family-primary;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;

    &:before {
      background: $color-text-black;
    }
  }

  .header__dropdown-list-title--margin-bottom-none {
    margin-bottom: 0;
  }

  .header__dropdown-link {
    margin-bottom: 8px;
    color: $color-black;
    font-weight: 400;
    font-family: $font-family-primary;
    
    .link {
      font-family: $font-family-secondary;
    }

    &:hover {

      &::before {
        background-color: $color-black;
      }
    }

    &::before {
      background-color: $color-black;
      transform: translateY(-1px);
    }
  }

  .header__dropdown-container-links-large-image-container {
    display: flex;
    flex-direction: column;

    @include desktop-up {
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    }
  }

  .header__dropdown-container-links-large-image-container .header__dropdown-container-inner-featured-menu-links-container {

    @include desktop-up {
      display: flex;
    }
  }

  .header__dropdown-container-links-large-image-container .header__dropdown-images--large-image-inner-container {
    display: flex;
    flex-direction: column;

    @include desktop-up {
      flex-direction: row;
      justify-content: flex-end;
    }
  }

  .header__dropdown-images-large-image {
    max-width: 224px;

    @include desktop-up {
      width: 290px;
      max-width: 100%;
    }
  }

  .header__dropdown-images-large-image img {
    display: block;
    width: 100%;
  }

  .header__dropdown-image-outer-container {
    margin-right: 32px;
  }

  .header__dropdown-image-outer-container:last-child {
    margin-right: 0;
  }

  .header__dropdown-images--large-image-container,
  .header__dropdown-images--large-image-inner-container {

    @include desktop-up {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  .header__dropdown-images--large-image-inner-container {

    @include desktop-up {
      display: flex;
    }
  }

  .header__dropdown-images--large-image-title {

    @include desktop-up {
      padding-top: 8px;
      padding-bottom: 16px;
      font-size: 20px;
      margin: 0;
      font-size: 18px;
      font-family: $font-family-primary;
      font-weight: 500;
    }
  }

  .header__dropdown-images--large-image-description {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .header__dropdown-images--large-image-description a {
    color: $color-brand-tertiary;
  }

  .header__dropdown-images--large-image-link {
    display: flex;
    cursor: pointer;

    &:hover {

      &::before {
        background-color: $color-brand-primary;
      }

      .menu-image-link-arrow svg {
        fill: $color-brand-primary;
      }
    }

    &:visited {

      .menu-image-link-arrow {
        fill: $color-brand-primary;
      }
    }

    &::before {
      background-color: $color-brand-primary;
    }
  }

  .header__dropdown-images--large-image-link .button--icon,
  .header-menu-image-title .button--icon {
    margin-left: 8px;
  }

  .header__dropdown-images--large-image-description-container {

    @include desktop-up {
      margin-left: 32px;
      max-width: 290px;
    }
  }

  .header-menu-image-title {
    margin-top: 16px;
  }

  .header-menu-image-title,
  .header__dropdown-images--large-image-link {
    margin: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: $color-brand-primary;
    display: inline-block;
    font-weight: 400;
  }

  .menu-image-link-arrow,
  .header-menu-image-title svg {
    fill: $color-brand-primary
  }

</style>
